import { render, staticRenderFns } from "./GoodTableSsr.vue?vue&type=template&id=759e5d64"
import script from "./GoodTableSsr.vue?vue&type=script&lang=js"
export * from "./GoodTableSsr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports